import { TicketRepository } from '../repositories/TicketRepository'

export function GetTicketDetailCase(ticketRepository: TicketRepository) {
  return async function (ticketId: string) {
    return await ticketRepository.ticketDetail(ticketId)
  }
}
